import { createConsumer } from '@rails/actioncable';

const CHANNEL_NAME = 'Integrations::OpenAI::Chatkit::RequestLiveAgentChannel';
const LIVE_AGENT_REQUEST_EVENT = 'chatkit.live-agent-request';

let consumer = null;
let liveAgentSubscription = null;

export const subscribeLiveAgentChannel = (container) => {
  if (liveAgentSubscription) return;

  const personId = container.dataset.personId;
  if (!personId) return;

  if (!consumer) {
    consumer = createConsumer();
  }

  liveAgentSubscription = consumer.subscriptions.create(
    { channel: CHANNEL_NAME, person_id: personId },
    {
      received(data) {
        document.dispatchEvent(new CustomEvent(LIVE_AGENT_REQUEST_EVENT, { detail: data }));
      }
    }
  );
};

export const unsubscribeLiveAgentChannel = () => {
  if (liveAgentSubscription) {
    liveAgentSubscription.unsubscribe();
    liveAgentSubscription = null;
  }
};
